module.exports = "/_next/static/images/cookie-notice-background-e85192de1428bc0736afdf7536fddc1c.png";